var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconButtonAift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0555626,0,0,0.0555626,-47.005,-16.1159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M957.393,355.602C901.861,367.957 905.268,423.779 933.725,443.663L1022.69,393.672L957.393,355.602Z",
    style: {
      fill: "rgb(4,4,4)",
      stroke: "black",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.982068,0,0,0.982068,20.7933,12.6686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1033.16,325.122C1066.39,324.821 1098.34,337.953 1121.75,361.54C1145.17,385.126 1158.07,417.168 1157.52,450.398C1156.83,492.648 1156.06,539.626 1155.37,581.512C1154.25,649.87 1100.03,705.501 1031.73,708.375C1030.97,708.407 1030.21,708.439 1029.45,708.471C976.253,710.709 930.959,670.16 927.32,617.042C923.902,567.14 919.675,505.429 915.995,451.714C913.764,419.142 925.07,387.093 947.245,363.131C969.419,339.169 1000.5,325.418 1033.14,325.122C1033.15,325.122 1033.15,325.122 1033.16,325.122Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "13.24px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1157.61,531.869C1166.75,373.691 1094.84,435.438 1094.84,435.438C1057.32,472.96 950.284,469.861 960,363.61C968.141,274.581 1197.22,282.778 1196.48,399.632C1254.27,451.754 1187.66,519.935 1187.66,519.935L1157.61,531.869Z",
    style: {
      fill: "rgb(4,4,4)",
      stroke: "black",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.72523,0,0,0.72523,318.62,149.502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215.44,
    cy: 544.148,
    r: 55.852,
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "17.93px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.551041,0,0,0.551041,550.302,240.153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1159.59,544.148C1159.59,513.322 1184.62,488.295 1215.44,488.295",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "23.59px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1189.28,540L1189.28,563.567",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.886612,0,0,0.886612,146.429,56.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1181.75,550.424L1193.58,550.424",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "14.66px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.72523,0,0,0.72523,318.62,149.502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1215.44,
    cy: 544.148,
    r: 55.852,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "17.93px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.847534,0,0,0.847534,184.267,109.364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1215.44,600C1184.62,600 1159.59,574.973 1159.59,544.148",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "15.34px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.847534,0,0,0.847534,-72.7364,-152.919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1215.44,600C1184.62,600 1159.59,574.973 1159.59,544.148",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "15.34px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1014.48,640.478C1031.33,657.332 1071.71,647.268 1072.59,617.23",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,20.4189,-10.9434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1066.61,578.894C1058.15,578.894 1051.28,572.025 1051.28,563.566",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 13
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-1.04622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 970.936,
    cy: 526.173,
    r: 10.936
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,105.156,-1.04622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 970.936,
    cy: 526.173,
    r: 10.936
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.70736,10.4947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1046.98,589.505C1025.24,589.505 1007.59,571.857 1007.59,550.119",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 13
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1002.88,560.614L1002.88,509.654C1002.88,504.975 1002.88,475.149 960,487.548",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.82,486.969C1043.09,476.297 1076.09,474.855 1090.23,484.555",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 13
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonAift);
export default __webpack_public_path__ + "static/media/iconButtonAIFT.a7b5fcf5.svg";
export { ForwardRef as ReactComponent };